<template>
  <v-app>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
      <v-toolbar-title class="ml-0 pl-3">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-img
        alt="Carexlogistics, S.L."
        class="shrink mt-1 hidden-sm-and-down"
        contain
        min-width="100"
        src="./assets/logo.png"
        width="100"
      />
      <v-spacer></v-spacer>

      <v-btn v-if="logueado" icon @click="salir()">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-if="logueado"
      v-model="drawer"
      app
      clipped
      color="grey lighten-4"
    >
      <v-list dense>
        <template v-if="esAdministrador">
          <v-list-item :to="{ name: 'cliente' }">
            <v-list-item-action>
              <v-icon>mdi-clipboard-account-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Cliente</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esAlmacenero || esClienteAlmacen">
          <v-list-item :to="{ name: 'cambiar_clave' }">
            <v-list-item-action>
              <v-icon>mdi-lock-reset</v-icon>
            </v-list-item-action>
            <v-list-item-title>Contraseña</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esAdministrador">
          <v-list-item :to="{ name: 'usuario' }">
            <v-list-item-action>
              <v-icon>mdi-account-multiple-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Usuarios</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esAdministrador || esAlmacenero">
          <v-list-item :to="{ name: 'articulo' }">
            <v-list-item-action>
              <v-icon>mdi-feature-search-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Artículos</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esAdministrador || esAlmacenero">
          <v-list-item :to="{ name: 'albaran' }">
            <v-list-item-action>
              <v-icon>mdi-folder-search-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Albaranes</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esAdministrador || esAlmacenero">
          <v-list-item :to="{ name: 'picking_y_packing' }">
            <v-list-item-action>
              <v-icon>mdi-dropbox</v-icon>
            </v-list-item-action>
            <v-list-item-title>Picking y Packing</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esClienteAlmacen">
          <v-list-item :to="{ name: 'cliente_picking_y_packing' }">
            <v-list-item-action>
              <v-icon>mdi-dropbox</v-icon>
            </v-list-item-action>
            <v-list-item-title>Picking y Packing</v-list-item-title>
          </v-list-item>
        </template>

        <template v-if="esClienteAlmacen">
          <v-list-item :to="{ name: 'cliente_articulo' }">
            <v-list-item-action>
              <v-icon>mdi-feature-search-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Artículos</v-list-item-title>
          </v-list-item>
        </template>

        <template>
          <v-list-item :to="{ name: 'tutorial' }">
            <v-list-item-action>
              <v-icon>mdi-clipboard-account-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Tutorial</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    logueado() {
      return !!this.$store.state.usuario;
    },
    esAdministrador() {
      console.log(
        "esAdministrador",
        this.$store.state.usuario && this.$store.state.usuario.rol == "Administrador"
      );
      return (
        this.$store.state.usuario && this.$store.state.usuario.rol == "Administrador"
      );
    },
    esAlmacenero() {
      console.log(
        "esAlmacenero",
        this.$store.state.usuario && this.$store.state.usuario.rol == "Almacenero"
      );
      return this.$store.state.usuario && this.$store.state.usuario.rol == "Almacenero";
    },
    esClienteAlmacen() {
      console.log("esClienteAlmacen", this.$store.state.usuario);
      console.log(
        "esClienteAlmacen",
        this.$store.state.usuario && this.$store.state.usuario.rol == "ClienteAlmacen"
      );
      return (
        this.$store.state.usuario && this.$store.state.usuario.rol == "ClienteAlmacen"
      );
    },
  },
  created() {
    this.$store.dispatch("autoLogin");
  },
  methods: {
    salir() {
      this.$store.dispatch("salir");
    },
  },
};
</script>
